import React from 'react';
import { Select, Form } from 'antd';
// import transportFieldsConnect from '../../../common/hoc/transportFieldsConnect';
// const Option = Select.Option;
const CompanyExecutor = ({ form }) => {
  const { getFieldDecorator } = form;
  return (
    <Form.Item label="Компания-исполнитель">
      {getFieldDecorator('companyExecutor')(
        <Select
          style={{ width: '100%' }}
          allowClear={true}
          className="ui-select"
          mode="multiple"
          placeholder="Выберите исполнителя"
          dropdownClassName="ui-select__dropdown-multiple"
          showArrow={true}
          maxTagCount={0}
          getPopupContainer={trigger => trigger.parentNode}
        ></Select>
      )}
    </Form.Item>
  );
};

export default CompanyExecutor;
